import axios from 'axios';

const API_BASE_URL = '/api/colleges';

const collegesService = {
  // Get all colleges with pagination and filters
  getAll: async (params = {}) => {
    const response = await axios.get(API_BASE_URL, {
      params,
      withCredentials: true
    });
    return response.data;
  },

  // Get single college by ID
  getById: async (id) => {
    const response = await axios.get(`${API_BASE_URL}/${id}`, {
      withCredentials: true
    });
    return response.data;
  },

  // Create new college
  create: async (data) => {
    const response = await axios.post(API_BASE_URL, data, {
      withCredentials: true
    });
    return response.data;
  },

  // Update college
  update: async (id, data) => {
    const response = await axios.put(`${API_BASE_URL}/${id}`, data, {
      withCredentials: true
    });
    return response.data;
  },

  // Delete college
  delete: async (id) => {
    const response = await axios.delete(`${API_BASE_URL}/${id}`, {
      withCredentials: true
    });
    return response.data;
  }
};

export default collegesService;

